angular.module('gym.components').directive('subscriptionPaymentDetails', function() {
  return {
    restrict: 'E',
    template: require('templates/components/subscriptions/subscription_payment_details.html.slim'),
    scope: {
      paymentMethod: '=',
      gym: '=',
      subscriptionToken: '=',
      setPaymentMethod: '&'
    },
    controller: ["$scope", "$stateParams", "$state", "$window", "$http", "$timeout", "loadingAnimation", "flash", "AdminUserService", function($scope, $stateParams, $state, $window, $http, $timeout, loadingAnimation, flash, AdminUserService) {
      var cardElement, cardReady, createToken, elements, getSetupIntent, onCardChange, saveCard, stripe;
      $scope.adminHasPermission = AdminUserService.has;
      stripe = Stripe($scope.subscriptionToken);
      elements = stripe.elements();
      cardReady = false;
      $scope.cardParams = {
        name: ''
      };
      cardElement = elements.create('card');
      cardElement.mount('#card');
      $scope.formReady = function() {
        return $scope.cardParams.name && cardReady;
      };
      onCardChange = function() {
        return cardElement.on('change', function(event) {
          return $timeout(function() {
            cardReady = event.complete;
            if (event.error) {
              return $scope.errors = event.error.message;
            } else {
              return $scope.errors = '';
            }
          });
        });
      };
      onCardChange();
      $scope.changePaymentMethod = function() {
        return $scope.paymentMethod.isEditing = true;
      };
      $scope.cancelCardEditing = function() {
        return $scope.paymentMethod.isEditing = void 0;
      };
      getSetupIntent = function() {
        var url;
        url = `/subscription_payment_methods/generate_intent?gymId=${$stateParams.gymId}`;
        return $http.post(url);
      };
      $scope.submitCard = function() {
        loadingAnimation.show();
        return getSetupIntent().then(function(response) {
          return createToken(response.data);
        }, function() {
          loadingAnimation.hide();
          return flash.error = "There was an error processing the request.";
        });
      };
      createToken = function(setupIntent) {
        var options;
        options = {
          billing_details: {
            name: $scope.cardParams.name
          }
        };
        return stripe.confirmCardSetup(setupIntent.client_secret, {
          payment_method: {
            card: cardElement,
            billing_details: options.billing_details
          }
        }).then(function(setupIntentResult) {
          return $timeout(function() {
            if (setupIntentResult.error) {
              $scope.errors = setupIntentResult.error.message;
              return loadingAnimation.hide();
            } else {
              return saveCard(setupIntentResult.setupIntent.payment_method);
            }
          });
        });
      };
      return saveCard = function(token) {
        var params, url;
        url = "/subscription_payment_methods";
        params = {
          gym_id: $stateParams.gymId,
          token: token,
          cardholderName: $scope.cardParams.name
        };
        return $http.post(url, params).then(function(response) {
          var subscriptionsUrl;
          if ($scope.gym.on_trial_period || $scope.paymentMethod.last_4) {
            $scope.gym.subscribed_externally = false;
            loadingAnimation.hide();
            return $scope.setPaymentMethod({
              paymentMethod: response.data
            });
          } else {
            subscriptionsUrl = $state.href('gym.subscription.tab', {
              tab: 'subscriptions'
            });
            return $window.open(subscriptionsUrl, '_self');
          }
        }, function(response) {
          loadingAnimation.hide();
          return flash.error = response.data.message || "There was an error processing the request.";
        });
      };
    }]
  };
});
